"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainablePropType;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _introspection = require("./internal/introspection");

// Factory for the .required version of the propType function.
// See https://www.ian-thomas.net/custom-proptype-validation-with-react/
function createChainablePropType(validate, propTypeName) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  function checkType(isRequired, props, propName, componentName) {
    if (props[propName] == null) {
      if (isRequired) {
        return new Error("Required prop `" + propName + "` was not specified in `" + componentName + "`.");
      }

      return null;
    }

    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return validate.apply(void 0, [props, propName, componentName].concat(rest));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  if ((0, _introspection.isIntrospectionEnabled)()) {
    var introspectionObj = {
      args: args,
      type: propTypeName
    };
    chainedCheckType.__INTROSPECTION__ = introspectionObj;
    chainedCheckType.isRequired.__INTROSPECTION__ = (0, _extends2.default)({}, introspectionObj, {
      isRequired: true
    });
  }

  return chainedCheckType;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/utils/propTypes/createChainablePropType.js
// module id = 25
// module chunks = 0